export class DisclaimerSettings {
  suppress_disclaimers: number[];

  constructor(obj?: any) {
    this.suppress_disclaimers =
      obj && obj.suppress_disclaimers ? obj.suppress_disclaimers : [];
  }
}
